import { URL_FOR_GENERATE_LEAD_TAG, URL_VISITED } from '../../config'

export function setGenerateLeadTag() {
  window.generateLeadTag = ''

  if (!URL_FOR_GENERATE_LEAD_TAG.includes(URL_VISITED)) return

  const $requestQuoteBtns = document.querySelectorAll('[aria-label="Pedir Presupuesto"]')

  $requestQuoteBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      window.generateLeadTag = 'Home'
    })
  })
}
